import { z } from "zod"
import { PaginationSchema } from "../shared/pagination_dtos"

export const UpsertNoteParamsSchema = z.object({ id: z.string().transform(BigInt) })

export const GetCustomerNotesSchema = z.object({
  ...PaginationSchema.shape,
  query: z.string().optional(),
  employeeId: z.string().transform(BigInt).optional(),
})

export const CreateNoteBodySchema = z.object({
  text: z.string(),
  conversationId: z.string().transform(BigInt).optional(),
})

export const UpsertNoteBodySchema = z.object({
  text: z.string(),
  conversationId: z.string().transform(BigInt).optional(),
})

export const DeleteNoteParamsSchema = z.object({ id: z.string().transform(BigInt) })
